const indexItems = [
  { label: '国产热播', desc: '最新国产剧同步追', icon: 'ri-fire-line', color: 'bg-primary-100 text-primary-600' },
  { label: '韩剧精选', desc: '高分韩剧一网打尽', icon: 'ri-heart-line', color: 'bg-accent-100 text-accent-700' },
  { label: '美剧专区', desc: '口碑美剧全集看', icon: 'ri-global-line', color: 'bg-secondary-100 text-secondary-700' },
  { label: '古装大戏', desc: '经典与新品齐备', icon: 'ri-building-2-line', color: 'bg-primary-100 text-primary-600' },
  { label: '悬疑探案', desc: '烧脑剧情停不下来', icon: 'ri-search-eye-line', color: 'bg-accent-100 text-accent-700' },
  { label: '甜宠剧场', desc: '甜蜜浪漫治愈人心', icon: 'ri-emotion-line', color: 'bg-secondary-100 text-secondary-700' },
  { label: '高分推荐', desc: '豆瓣8分以上好剧', icon: 'ri-star-line', color: 'bg-primary-100 text-primary-600' },
  { label: '最新上架', desc: '本周新增剧集一览', icon: 'ri-rocket-line', color: 'bg-accent-100 text-accent-700' },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-900 mb-3">
            追剧专题
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            按类型快速找到你想看的电视剧，国产剧、韩剧、美剧全集在线观看
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4">
          {indexItems.map((item) => (
            <a
              key={item.label}
              href="#index"
              onClick={(e) => e.preventDefault()}
              className="group flex flex-col items-center text-center p-5 md:p-7 bg-background-50 border border-background-200/70 rounded-xl hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className={`w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-xl ${item.color} mb-3 md:mb-4 group-hover:scale-110 transition-transform duration-300`}>
                <i className={`${item.icon} text-xl md:text-2xl`}></i>
              </div>
              <h3 className="text-sm md:text-base font-semibold text-foreground-900 mb-1 whitespace-nowrap">{item.label}</h3>
              <p className="text-xs text-foreground-500">{item.desc}</p>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}